import {
  UPLOAD_REQUEST,
  UPLOAD_SUCCESS,
  UPLOAD_FAIL,
} from "../constants/AuthConstant";

import axios from "axios";
import { toast } from "react-toastify";

export const ResumeUploadAction = (data,navigate) => {

  return function (dispatch) {
    dispatch({
      type: UPLOAD_REQUEST,
      payload: true,
    });

    let OPTION = {
      url: `${process.env.REACT_APP_API_PATH}/ebench/upload_resume`,
      method: "PUT",
      data: data,
      headers: {
        "content-Type": "multipart/form-data",
      },
    };

    axios(OPTION)
      .then((res) => {
        dispatch(createDashboardBannerPre(res.data,navigate));
      })
      .catch((error) => {
        dispatch({
          type: UPLOAD_FAIL,
          payload: false,
          error: error,
          msg: "Failed to load the information",
        });
        console.log("error", error.response.data.status.message);
        toast.error(error?.response?.data?.status?.message);
      });
  };
};
export const createDashboardBannerPre = (data,navigate) => {
  toast.success("Uploaded Successfully!");
  //  window.location.href = "/candidate_dashboard";

  // setTimeout(() => {
  //   navigate('/candidate_dashboard')
  // }, 1500);

  return {
    type: UPLOAD_SUCCESS,
    result: data,
    payload: false,
    msg: "SUCCESS",
  };
};

export const ResumeDownloadAction = (id) => {

  return function (dispatch) {
    dispatch({
      type: UPLOAD_REQUEST,
      payload: true,
    });

    let OPTION = {
      url: `${process.env.REACT_APP_API_PATH}/ebench/file/download?candidateID=${id}`,
      method: "GET",
     
      headers: {
        "content-type": "application/json",
        responseType: 'blob',
      },
    };

    axios(OPTION)
      .then((res) => {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'file.pdf');
        document.body.appendChild(link);
        link.click();
        dispatch(DownloadResumePre(res.data));
      })
      .catch((error) => {
        dispatch({
          type: UPLOAD_FAIL,
          payload: false,
          error: error,
          msg: "Failed to load the information",
        });
        toast.error("Failed To download");
      });
  };
};
export const DownloadResumePre = (data) => {
  toast.success("Downloaded Successfully!");
  return {
    type: UPLOAD_SUCCESS,
    result: data,
    payload: false,
    msg: "SUCCESS",
  };
};